module.exports = __webpack_public_path__ + "img/CUSHION.e9f59011.png";